import { BaseResourceModel } from './base-resource.model';

export class Plataforma extends BaseResourceModel {
    constructor(
        public nome?: string,
        public descricao?: string,
        public situacao?: string
    ) {
        super();
    }

    static fromJson(jsonData: any): Plataforma {
        return Object.assign(new Plataforma(), jsonData);
    }
}
